export default "__VITE_ASSET__7d036f88__"